import { inject, provideEnvironmentInitializer, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@dro/app/app.component';
import { provideNgxMask } from 'ngx-mask';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withRouterConfig, withViewTransitions } from '@angular/router';
import { routes } from '@dro/app/app.routing';
import { localizationConfig } from '@td/i18n';
import { authInterceptor, httpErrorsInterceptor } from '@dro/app/core/http';
import { googleMapsInitializer, httpHostInterceptor, withEnvironment } from '@td/core';
import { environment } from '@dro/environments/environment';
import { provideHoneybadger } from '@td/errors';
import { provideAnalytics } from '@td/google-analytics';
import { provideTransloco } from '@jsverse/transloco';
import { DepartmentsStore } from '@dro/app/core/stores/departments';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    withEnvironment(environment),
    provideNgxMask(),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([httpHostInterceptor, httpErrorsInterceptor, authInterceptor]),
    ),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withViewTransitions(),
    ),
    provideHoneybadger(),
    provideAnalytics(environment.gaId),
    googleMapsInitializer(),
    provideTransloco(localizationConfig),
    provideEnvironmentInitializer(() => inject(DepartmentsStore)),
  ],
}).catch((err) => console.error(err));
